module.exports = __webpack_public_path__ + "static/js/0.41e957e0.chunk.worker.js"